import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="unsaved-changes"
export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.isDirty = false;
    this._onBeforeVisit = this.onBeforeVisit.bind(this);
    this._onBeforeUnload = this.onBeforeUnload.bind(this);

    window.addEventListener("beforeunload", this._onBeforeUnload);
    document.addEventListener("turbo:before-visit", this._onBeforeVisit);
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this._onBeforeVisit)
    window.removeEventListener("beforeunload", this._onBeforeUnload)
  }

  markDirty() {
    this.isDirty = true
  }

  onBeforeVisit(event) {
    if (!this.isDirty) return

    if (!confirm("These changes will not be saved. Are you sure?")) {
      event.preventDefault()
    }
  }

  onBeforeUnload(event) {
    if (!this.isDirty) return;
    event.preventDefault();
    event.returnValue = "";
  }

  submit() {
    this.isDirty = false;
  }
}
